export function headerInit() {
  const button = document.getElementById("mainHeaderMenuToggle");
  const menu = document.getElementById("mainHeaderNav");
  if (!button || !menu) return;

  const currentPath = window.location.pathname.replace(/\/$/, "") || "/";
  menu.querySelectorAll("a").forEach(anchor => {
    const anchorPath = new URL(anchor.href, window.location.href).pathname.replace(/\/$/, "") || "/";
    if (anchor.origin === window.location.origin && anchorPath === currentPath) {
      anchor.setAttribute("aria-current", "page");
    }
  });

  const close = () => {
    button.setAttribute("aria-expanded", "false");
    menu.removeAttribute("data-open");
  };

  button.addEventListener("click", () => {
    const open = button.getAttribute("aria-expanded") === "true";
    button.setAttribute("aria-expanded", String(!open));
    menu.toggleAttribute("data-open", !open);
  });
  menu.addEventListener("click", event => {
    if (event.target.closest("a")) close();
  });
  document.addEventListener("keydown", event => {
    if (event.key === "Escape") close();
  });
  window.addEventListener("resize", () => {
    if (window.innerWidth > 760) close();
  });
}
